// extracted by mini-css-extract-plugin
export var card = "_6w-0";
export var expandedCard = "_6w-2";
export var paginated = "_6w-1";